import Hubspot from '../../services/Hubspot';

export default {
    init(instance) {
        document.addEventListener('alpine:init', () => {
            instance.data('businessNameInformationForm', () => ({
                inputs: {
                    email: '',
                    entity_state: '',
                    your_industry: '',
                    agree: false,
                },
                errors: {},
                showMessage: false,
                successMessage: false,
                errorMessage: false,

                validateField(fieldName) {
                    delete this.errors[fieldName];

                    switch (fieldName) {
                        case 'email':
                            if (!this.inputs.email.trim()) {
                                this.errors.email = 'Please complete this required field.';
                            } else if (!this.validateEmail(this.inputs.email)) {
                                this.errors.email = 'Email must be formatted correctly.';
                            }
                            break;

                        case 'entity_state':
                            if (!this.inputs.entity_state) {
                                this.errors.entity_state = 'Please complete this required field.';
                            }
                            break;
                        
                        case 'your_industry':
                            if (!this.inputs.your_industry) {
                                this.errors.your_industry = 'Please complete this required field.';
                            }
                            break;

                        case 'agree':
                            if (!this.inputs.agree) {
                                this.errors.agree = 'Please complete this required field.';
                            }
                            break;

                        default:
                            break;
                    }
                },

                validateAll() {
                    this.errors = {};

                    Object.keys(this.inputs).forEach((fieldName) => {
                        this.validateField(fieldName);
                    });
                },

                validateEmail(email) {
                    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                    return re.test(email.toLowerCase());
                },

                async submitForm() {
                    this.validateAll();

                    if (Object.keys(this.errors).length > 0) {
                        return;
                    }

                    const payload = {
                        email: this.inputs.email,
                        entity_state: this.inputs.entity_state,
                        your_industry: this.inputs.your_industry,
                    };

                    try {
                        const { data } = await Hubspot.checkNameInformation(payload);
                        if (data.success) {
                            this.showMessage = true;
                            this.successMessage = data.data.inlineMessage;
                            this.errorMessage = false;
                            this.resetForm();
                        } else {
                            console.error('Failed to submit form');
                            this.showMessage = true;
                            this.successMessage = '';
                            this.errorMessage = 'Failed to submit form, try again.';
                        }
                    } catch (error) {
                        console.error('Error:', error);
                        this.showMessage = true;
                        this.successMessage = '';
                        this.errorMessage = 'Failed to submit form, try again.';
                    }
                },

                resetForm() {
                    this.inputs.email = '';
                    this.inputs.entity_state = '';
                    this.inputs.your_industry = '';
                    this.inputs.agree = false;
                    this.errors = {};
                    const formWrapper = document.getElementById('form-wrapper');

                    if (formWrapper) {
                        formWrapper.scrollIntoView({ behavior: 'smooth' });
                    }
                },
            }));
        });
    },
};
